// extracted by mini-css-extract-plugin
module.exports = {"FormTextarea":"FormTextarea_FormTextarea__6ng7f","Label":"FormTextarea_Label__pwFO3","Textarea":"FormTextarea_Textarea__rLy_0","Error":"FormTextarea_Error__O8LBz"};